import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { MDBDataTable } from "mdbreact";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { toast } from "react-toastify";

const TabelaExames = (props) => {
  const [modal, setModal] = useState(false);
  const [arquivoVisualizado, setArquivoVisualizado] = useState(null);
  const [arquivos, setArquivos] = useState([]); // Novo estado para armazenar arquivos
  const [data, setData] = useState({
    columns: [
      { label: "ID", field: "id", sort: "asc", width: 150 },
      { label: "Data", field: "created_at", sort: "asc", width: 150 },
      { label: "Arquivo", field: "nome_arquivo", sort: "asc", width: 150 },
      { label: "Ações", field: "acoes", sort: "asc", width: 150 },
    ],
    rows: [],
  });

  const { id } = useParams();
  const toggleModal = () => setModal(!modal);

  const formatarData = (data) => {
    const date = new Date(data);
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  };

  useEffect(() => {
    if (props && props?.cliente) {
      setArquivos(props.cliente.arquivos); // Atualiza o estado de arquivos com os dados vindos de props
    }
  }, [props]); // Atualiza o estado sempre que a prop arquivos mudar

  useEffect(() => {
    const getArquivos = () => {
      if (arquivos.length > 0) {
        setData((prevData) => ({
          ...prevData,
          rows: arquivos.map((arquivo) => ({
            id: arquivo.id,
            created_at: formatarData(arquivo.created_at),
            nome_arquivo: arquivo.nome_arquivo,
            acoes: (
              <Button color="info" onClick={() => visualizarArquivo(arquivo)}>
                Visualizar
              </Button>
            ),
          })),
        }));
      }
    };

    getArquivos();
  }, [arquivos]); // Atualiza a tabela sempre que o estado de arquivos mudar

  const visualizarArquivo = (arquivo) => {
    setArquivoVisualizado(arquivo);
    toggleModal();
  };

  const copiarLink = () => {
    navigator.clipboard.writeText(window.location.href);
    toast.success("Link copiado para a área de transferência!");
  };

  return (
    <>
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <Button color="primary" onClick={copiarLink}>
                Copiar link de exames do cliente
              </Button>
              {arquivos.length > 0 ? (
                <MDBDataTable striped responsive bordered data={data} />
              ) : (
                <p>Nenhum arquivo encontrado.</p>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* Modal para visualizar o arquivo */}
      <Modal isOpen={modal} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>Visualizar Arquivo</ModalHeader>
        <ModalBody>
          {arquivoVisualizado ? (
            <iframe
              src={`https://documentos-olis.s3.us-east-2.amazonaws.com/${arquivoVisualizado.nome_arquivo}`}
              title="Visualização do Arquivo"
              width="100%"
              height="500px"
              frameBorder="0"
            />
          ) : (
            <p>Carregando...</p>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default TabelaExames;
